import React from "react";
import Grid from "@mui/material/Grid";
import { getAssets } from "@unisearch/helpers";
import styles from "./counsellor_hero.module.scss";
import Image from "next/legacy/image";

export const CounsellorHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={{ xs: 2, sm: 2, md: 3 }} alignItems="center">
          <Grid item xs={12} sm={12} md={6}>
            <h1 className={styles.title}>
              Find Your Study Abroad{" "}
              <span className={"mark"}> Counsellor </span>
            </h1>
            <p className={`${styles.sub_title} font-medium`}>
              Not sure where to begin with your study abroad research? Too
              overwhelmed by the process to begin? Our expert team of
              counsellors are available around the clock to help you every step
              of the way!
            </p>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <Image
                layout="responsive"
                width={573}
                height={490}
                blurDataURL={getAssets(
                  "assets/images/study/country_placeholder.webp"
                )}
                placeholder="blur"
                src={getAssets(
                  "/assets/images/counsellor/counsellor-hero-img.webp"
                )}
                alt="hero image"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default CounsellorHero;
